"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElphaThemeProvider = exports.theme = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var foundation_1 = require("./foundation");
var styles_1 = require("@mui/material/styles");
exports.theme = (0, material_1.createTheme)({
    // foundation
    typography: foundation_1.typography,
    palette: foundation_1.palette,
    shadows: foundation_1.shadows,
    breakpoints: foundation_1.breakpoints,
    // components
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: foundation_1.palette.primary[700],
                },
                html: {
                    fontSize: '62.5%',
                    scrollBehavior: 'smooth',
                },
            },
        },
    },
});
var ElphaThemeProvider = function (_a) {
    var children = _a.children;
    return (0, jsx_runtime_1.jsx)(styles_1.ThemeProvider, __assign({ theme: exports.theme }, { children: children }));
};
exports.ElphaThemeProvider = ElphaThemeProvider;
